import React from 'react';
import { Container, Grid, Segment, Header, Image } from "semantic-ui-react";
import PropTypes from "prop-types";

import './Experience.css';
import headshot from './headshot2.png';

const Experience = ({ image, copy }) => {
  return (
    <Segment basic padded>
      <Container>
        <Grid stackable columns="2">
          <Grid.Column width="10">
            <Segment vertical textAlign='center'>
              <Segment basic textAlign='left'>
                <Header as='h2'>{copy.header}</Header>
              </Segment>
              {copy.paragraphs.map((para, i) => {
                return (
                  <Segment key={i} basic textAlign='left' className='paragraph'>
                    <p>{para}</p>
                  </Segment>
                );
              })}
            </Segment>
          </Grid.Column>
          <Grid.Column width="6" className='imageContainer'>
            <Segment vertical textAlign='center' >
              <Image src={headshot} size='medium' circular/>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    </Segment>
  );
};

Experience.propTypes = {
  image: PropTypes.string.isRequired,
  copy: PropTypes.object.isRequired
}


export default Experience;


// WEBPACK FOOTER //
// ./src/Experience/Experience.js